export default __webpack_public_path__ + "assets/audios/ea1c3640d110b54538bb1bc280137bb1.mp3";